import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_OUTBOUND_COMPANY_PARAM_KEY,
  SUBMENU_PARAM_KEY,
} from '../../../constants/route'
import { LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY } from '../../../constants/storage'
import { useSubMenuActions } from '../../../hooks'
import { getItemsFromApiResponse } from '../../../utils/api'
import { setStorageSerializedItem } from '../../../utils/storage'
import { Divider } from '../../Divider'
import { SUBMENU_ITEM_KEYS, SubMenuWrapper } from '../../SubMenu'
import { getIdwellToIdwellOutboundCompanies } from '../IdwellToIdwell.api'
import { IdwellToIdwellSubMenuAvailableItemsSection } from '../IdwellToIdwellSubMenuAvailableItemsSection'
import { IdwellToIdwellSubMenuFiltersSection } from '../IdwellToIdwellSubMenuFiltersSection'

import {
  FILTER_NAME_OUTBOUND_UUID,
  ITEM_KEYS,
  QA_NAME_IDWELL_TO_IDWELL_SUB_MENU,
} from './IdwellToIdwellSubMenu.constants'
import { useDefaultIdwellToIdwellParams } from './IdwellToIdwellSubMenu.hooks'
import {
  getSubMenuIdwellToIdwellActiveValue,
  getSubMenuIdwellToIdwellDefaultValue,
} from './IdwellToIdwellSubMenu.utils'

import * as styles from './IdwellToIdwellSubMenu.module.css'

function IdwellToIdwellSubMenu({ menuTitle, show: isVisible, subMenu }) {
  const { idwellToIdwellCompanies = EMPTY_LIST, items = EMPTY_LIST } =
    subMenu || EMPTY_OBJECT

  const { setSubMenuIdwellToIdwellCompanies } = useSubMenuActions()

  const [searchParams, setSearchParams] = useSearchParams()

  const [selectedOutboundCompany, setSelectedOutboundCompany] = useState(null)

  useDefaultIdwellToIdwellParams({ outboundCompanies: idwellToIdwellCompanies })

  const activeCompany = searchParams.get(SUBMENU_OUTBOUND_COMPANY_PARAM_KEY)
  const sub = searchParams.get(SUBMENU_PARAM_KEY)
  const activeCompanyFromApi = searchParams.get(FILTER_NAME_OUTBOUND_UUID)

  useEffect(() => {
    if (activeCompanyFromApi) {
      setSearchParams(
        prev => {
          prev.set(SUBMENU_OUTBOUND_COMPANY_PARAM_KEY, activeCompanyFromApi)
          prev.delete(FILTER_NAME_OUTBOUND_UUID)

          return prev
        },
        { replace: true }
      )
    }
  }, [activeCompanyFromApi])

  function setIdwellToIdwellMenu() {
    getIdwellToIdwellOutboundCompanies().then(response => {
      const outboundCompanies = getItemsFromApiResponse(response) || EMPTY_LIST

      setSubMenuIdwellToIdwellCompanies(outboundCompanies)
    })
  }

  function handleSelectOutboundCompany(item) {
    setSearchParams(params => {
      params.set(
        SUBMENU_OUTBOUND_COMPANY_PARAM_KEY,
        item[ITEM_KEYS.selectedKey]
      )
      params.set(SUBMENU_PARAM_KEY, SUBMENU_DEFAULT_VALUE)

      return params
    })
  }

  function handleClickSubFilter(value) {
    if (sub === value) {
      return
    }

    setSearchParams(prev => {
      prev.set(SUBMENU_PARAM_KEY, value)

      return prev
    })
  }

  useEffect(() => {
    setIdwellToIdwellMenu()
  }, [])

  useEffect(() => {
    if (activeCompany && !isEmpty(idwellToIdwellCompanies)) {
      const activeValue = getSubMenuIdwellToIdwellActiveValue({
        outboundCompanies: idwellToIdwellCompanies,
        value: activeCompany,
      })

      if (activeValue) {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- applies the resolved outbound company
        setSelectedOutboundCompany(activeValue)

        setStorageSerializedItem(
          LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY,
          activeValue[ITEM_KEYS.selectedKey]
        )
      } else {
        handleSelectOutboundCompany(
          getSubMenuIdwellToIdwellDefaultValue(idwellToIdwellCompanies)
        )
      }
    }
  }, [activeCompany, handleSelectOutboundCompany, idwellToIdwellCompanies])

  const listItemsOptions = {
    ...ITEM_KEYS,
    className: styles.availableItemsSection,
    items: idwellToIdwellCompanies,
    selected: selectedOutboundCompany,
    onClick: handleSelectOutboundCompany,
  }

  const filtersProps = {
    apiKeys: SUBMENU_ITEM_KEYS,
    isActive: item => item[SUBMENU_ITEM_KEYS.value] === sub,
    items,
    onClickItem: handleClickSubFilter,
  }

  if (!isVisible || idwellToIdwellCompanies.length === 0) {
    return null
  }

  return (
    <SubMenuWrapper
      className={styles.wrapperSubmenu}
      qaName={QA_NAME_IDWELL_TO_IDWELL_SUB_MENU}
    >
      <span className={styles.subTitle}>{menuTitle}</span>
      <IdwellToIdwellSubMenuFiltersSection {...filtersProps} />
      <Divider className={styles.divider} />
      <div className={styles.SubMenuIdwellToIdwell}>
        <IdwellToIdwellSubMenuAvailableItemsSection {...listItemsOptions} />
      </div>
    </SubMenuWrapper>
  )
}

export default IdwellToIdwellSubMenu
